import React, { createContext, useContext, useMemo } from "react";
import { useMedia } from "use-media";

// TODO: Use another package but I don't know which one :(

const BreakpointsContext = createContext({
  isComputed: false,
  mobile: true,
  tablet: true,
  desktop: true,
  isTabletToDesktop: false,
});

const breakpoints = {
  isComputed: "(min-width: 0px)",
  mobile: "(min-width: 0px)",
  tablet: "(min-width: 625px)",
  largetTablet: "(min-width: 900px)",
  desktop: "(min-width: 1010px)",
  largeDesktop: "(max-width: 1010px)",
  megaLargeDesktop: "(max-width: 1142px)",
};

export const BreakpointsProvider = ({ children }) => {
  const isComputed = useMedia(breakpoints.isComputed);
  const mobile = useMedia(breakpoints.mobile);
  const tablet = useMedia(breakpoints.tablet);
  const largetTablet = useMedia(breakpoints.largetTablet);
  const desktop = useMedia(breakpoints.desktop);
  const largeDesktop = useMedia(breakpoints.largeDesktop);
  const megaLargeDesktop = useMedia(breakpoints.megaLargeDesktop);

  const value = useMemo(() => {
    const isComputedMobileScreen = isComputed && !tablet;
    const isComputedDesktopScreen = isComputed && desktop;
    const isComputedLessThanDesktopScreen =
      isComputed && desktop && !largeDesktop;
    const isTabletToDesktop = largetTablet && megaLargeDesktop;

    return {
      isComputed,
      mobile,
      tablet,
      desktop,
      isTabletToDesktop,
      isComputedMobileScreen,
      isComputedDesktopScreen,
      isComputedLessThanDesktopScreen,
    };
  }, [
    isComputed,
    tablet,
    desktop,
    largeDesktop,
    mobile,
    largetTablet,
    megaLargeDesktop,
  ]);

  return (
    <BreakpointsContext.Provider value={value}>
      {children}
    </BreakpointsContext.Provider>
  );
};

export function useBreakpoints() {
  return useContext(BreakpointsContext);
}
